export const ContactReportReason = {
    EmailIncorrect: "Email",
    MobileIncorrect: "MobilePhone",
    DirectIncorrect: "DirectPhone",
    CompanyIncorrect: "Company",
    RoleIncorrect: "JobTitle",
    Other: "Other",
} as const;

export type ContactReportReason = (typeof ContactReportReason)[keyof typeof ContactReportReason];
